import { React } from '../common';
import { IosKeyboardAvoidingView } from '../common/IosKeyboardAvoidingView';

export const WithKeyboard = ({
    children,
    enabled = true,
}) => <IosKeyboardAvoidingView allPlatforms enabled={enabled} addHeight={0}>{children}</IosKeyboardAvoidingView>;
